/**
 * Formats a phone object { countryCode, number } into a readable string.
 * Also handles legacy string phone numbers.
 */
export const formatPhoneNumber = (phone) => {
    if (!phone) return '—';
    
    // Handle legacy string data
    if (typeof phone === 'string') return phone;
    
    // Handle object data
    if (phone.countryCode && phone.number) {
        return `${phone.countryCode} ${phone.number}`;
    }
    
    return phone.number || '—';
};
